import { useEffect, useState } from 'react';
import { estadoBalanca, inscreverBalanca } from './balanca';

// Estado da balança pra tela: conexão + última leitura (atualiza sozinho).
export const useBalanca = () => {
  const [estado, setEstado] = useState(estadoBalanca());
  useEffect(() => {
    setEstado(estadoBalanca());
    return inscreverBalanca(() => setEstado(estadoBalanca()));
  }, []);
  return estado;
};
